/* eslint-disable @typescript-eslint/no-explicit-any */
import styled, { SpaceProps, BorderProps, device, css } from 'styles/styled'
import {
  InputStyles,
  SuccessInputStyles,
  WarningInputStyles,
  ErrorInputStyles,
  allowedProps,
} from '../style'
import { IFeedback, TCustomStyle } from '../types'

interface IInput extends IFeedback, SpaceProps, BorderProps {
  $width?: string | any[]
  $height?: string | any[]
  $customStyle?: TCustomStyle
  $resize?: boolean
}

export const StyledTextarea = styled('textarea').withConfig({
  shouldForwardProp: (prop, defaultValidatorFn) =>
    ![...allowedProps].includes(prop) && defaultValidatorFn(prop),
})<IInput>`
  height: ${({ $height }) => ($height ? $height : 'auto')};
  min-height: ${({ $height }) => ($height ? 'auto' : '80px')};
  resize: ${({ $resize }) => ($resize === false ? 'none' : 'both')};
  ${({ $height }) =>
    !$height &&
    css`
      ${device.large} {
        min-height: 100px;
      }
    `}
  ${InputStyles};
  ${({ $state, $showState, $showErrorOnly }) =>
    $state === 'success' &&
    !!$showState &&
    !$showErrorOnly &&
    SuccessInputStyles};
  ${({ $state, $showState, $showErrorOnly }) =>
    $state === 'warning' &&
    !!$showState &&
    !$showErrorOnly &&
    WarningInputStyles};
  ${({ $state, $showState, $showErrorOnly }) =>
    $state === 'error' && !!$showState && !!$showErrorOnly && ErrorInputStyles};
`
